// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemRadiantExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-radiant.svg?react';
import { createIcons } from '../../Icon';
const GemRadiantIcon = /* @__PURE__ */ createIcons('GemRadiant', {
    extended: GemRadiantExtended
});
GemRadiantIcon.supportedTypes = [
    'extended'
];
GemRadiantIcon.category = 'entities';
export default GemRadiantIcon;
